/**
 * Application Constants
 * 
 * TODO: Move these to .env file for production use
 * For now, keeping here for convenience during development
 */

// API Configuration — в .env задать REACT_APP_API_URL (например http://localhost:8000)
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Telegram Bot Configuration (if needed for future features)
export const TELEGRAM_CONFIG = {
  // Add telegram bot tokens here if needed
  // PROMOCODE_BOT_TOKEN: '',
  // XPARI_PROMOCODE_TOKEN: '',
};

// Application Settings
export const APP_CONFIG = {
  // Application name
  APP_NAME: 'Promocodes Admin',
  
  // Default locale
  DEFAULT_LOCALE: 'en',
  
  // Supported locales
  SUPPORTED_LOCALES: ['en', 'ru'] as const,
  
  // Pagination
  DEFAULT_PAGE_SIZE: 5,
  
  // API timeout (in milliseconds)
  API_TIMEOUT: 30000,
};

// Bot Names Configuration
export const BOT_NAMES = {
  XPARI_PROMOCODES_BOT: {
    name: 'xpari_promocodes_bot',
    humanName: 'XPari Promocodes',
    human_readable_name: 'XPari Promocodes',
  },
  LINE_PROMOCODES_BOT: {
    name: 'line_promocodes_bot',
    humanName: 'Line Promocodes',
    human_readable_name: 'Line Promocodes',
  },
};

// Helper function to get all bot names
export const getAllBotNames = () => {
  return Object.values(BOT_NAMES);
};

// Helper function to get human readable bot name
export const getHumanReadableBot = (botName: string): string => {
  const bot = Object.values(BOT_NAMES).find(b => b.name === botName);
  return bot?.human_readable_name || botName;
};

// Storage paths
export const STORAGE_PATHS = {
  STORAGE: '/storage',
  FONTS: '/fonts',
};

// Route paths
export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  LOGIN_SESSION_EXPIRED: '/auth/login?session_expired=1',
  CATEGORY_PROMOCODE_TEMPLATES: (id: number | string) => `/category/${id}/promocode-templates`,
  CATEGORIES: '/',
  CATEGORY_CREATE: '/category/create',
  CATEGORY_EDIT: (id: number) => `/category/edit/${id}`,
  PROMOCODE_TEMPLATES: '/promocode-template',
  PROMOCODE_TEMPLATE_CREATE: '/promocode-template/create',
  PROMOCODE_TEMPLATE_EDIT: (id: number | string) => `/promocode-template/edit/${id}`,
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_CREATE: '/admin/users/create',
  ADMIN_USER_EDIT: (id: number | string) => `/admin/users/edit/${id}`,
  TELEGRAM_ACCESS: '/telegram-access',
  TELEGRAM_ACCESS_CREATE: '/telegram-access/create',
  TELEGRAM_ACCESS_EDIT: (id: number | string) => `/telegram-access/edit/${id}`,
};

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/v1/admin/auth/login',
    REFRESH: '/api/v1/admin/auth/refresh',
  },
  CATEGORIES_LIST: '/api/v1/admin/categories',
  CATEGORY_GET: (id: number | string) => `/api/v1/admin/categories/${id}`,
  CATEGORY_PROMOCODE_TEMPLATES: (id: number | string) => `/api/v1/admin/categories/${id}/promocode-templates`,
  TEMPLATES: '/api/v1/admin/templates',
  TEMPLATE: (id: number | string) => `/api/v1/admin/templates/${id}`,
  FONTS: '/api/v1/fonts',
  USERS_LIST: '/api/v1/admin/users',
  USER_GET: (id: number | string) => `/api/v1/admin/users/${id}`,
  ROLES_LIST: '/api/v1/admin/roles',
  TELEGRAM_USERS_LIST: '/api/v1/admin/telegram-users',
  TELEGRAM_USER_GET: (id: number | string) => `/api/v1/admin/telegram-users/${id}`,
  CATEGORIES: (bot: string) => ({
    LIST: `/${bot}/categories`,
    CREATE: `/${bot}/category/store`,
    UPDATE: (id: number) => `/${bot}/category/update/${id}`,
    DELETE: (id: number) => `/${bot}/category/delete/${id}`,
    TOGGLE_HIDDEN: (id: number) => `/${bot}/category/toggleHidden/${id}`,
    SEARCH: `/${bot}/category/search`,
    GET: (id: number) => `/${bot}/category/${id}`,
    PROMOCODE_TEMPLATES: (id: number) => `/${bot}/category/${id}/promocode-templates`,
  }),
  PROMOCODE_TEMPLATES: (bot: string) => ({
    LIST: `/${bot}/promocode-template/`,
    CREATE: `/${bot}/promocode-template/store`,
    UPDATE: (id: number) => `/${bot}/promocode-template/update/${id}`,
    DELETE: (id: number) => `/${bot}/promocode-template/delete/${id}`,
    GET: (id: number) => `/${bot}/promocode-template/edit/${id}`,
    TEST: (id: number) => `/${bot}/promocode-template/test/${id}`,
  }),
  LOCALE: '/lang',
};

// Default values
export const DEFAULTS = {
  // Promocode template defaults
  PROMOCODE_TEMPLATE: {
    COLOR: '#ffffff',
    SUBSTRATE_BACKGROUND_COLOR: '#ffffff',
    UPPER_RADIUS: 1,
    SIDES_RADIUS: 1,
    BORDER_SIZE: 0,
    BORDER_COLOR: '#000000',
    SHADOW_BOLD: 50,
    SHADOW_UPPER_SIZE: 10,
    SHADOW_SIDES_SIZE: 10,
    HEADER_TEXT: 'PROMO-CODE',
    HEADER_COLOR: '#000000',
  },
};
